import { cursor, setCursorLabel } from '@/animations/cursor'

const handlers = new WeakMap()

// v-cursor="'Listen'": muestra esa etiqueta en el cursor custom al pasar por encima.
export default {
  bind(el, binding) {
    const state = { label: binding.value }
    const onEnter = (e) => {
      if (e.pointerType === 'mouse') setCursorLabel(state.label)
    }
    const onLeave = () => setCursorLabel('')
    el.addEventListener('pointerenter', onEnter)
    el.addEventListener('pointerleave', onLeave)
    handlers.set(el, { state, onEnter, onLeave })
  },
  update(el, binding) {
    const h = handlers.get(el)
    if (h) h.state.label = binding.value
  },
  unbind(el) {
    const h = handlers.get(el)
    if (!h) return
    el.removeEventListener('pointerenter', h.onEnter)
    el.removeEventListener('pointerleave', h.onLeave)
    if (cursor.label === h.state.label) setCursorLabel('')
    handlers.delete(el)
  }
}
